import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHero, Reveal, PlaceholderNote } from "@/components/public/Shared";

export default function About() {
  const [sections, setSections] = useState(null);

  useEffect(() => {
    api.get("/public/about").then((r) => setSections(r.data)).catch(() => setSections([]));
  }, []);

  return (
    <div data-testid="about-page">
      <PageHero
        title="About Us"
        subtitle="Christ Church CNI, Rajpura — a congregation of the Church of North India, Chandigarh Diocese."
        image="https://images.unsplash.com/photo-1599073472048-578c99bbe801?q=80&w=1800&auto=format&fit=crop"
      />
      <div className="mx-auto max-w-4xl px-5 py-16 sm:px-8 sm:py-24">
        {!sections && <p className="text-muted-foreground">Loading…</p>}
        <div className="space-y-16">
          {(sections || []).map((sec, i) => (
            <Reveal key={sec.section_key} delay={0.05}>
              <section data-testid={`about-section-${sec.section_key}`}>
                <div className="flex items-start gap-5">
                  <span className="mt-1 hidden font-heading text-5xl font-black text-gold/30 sm:block">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div>
                    <h2 className="font-heading text-2xl sm:text-3xl font-bold text-navy">{sec.title}</h2>
                    <div className="mt-3 h-0.5 w-14 bg-gold" aria-hidden="true" />
                    <p className="mt-5 text-base leading-relaxed text-foreground/80 whitespace-pre-line">{sec.body}</p>
                  </div>
                </div>
              </section>
            </Reveal>
          ))}
        </div>
        <PlaceholderNote />
      </div>
    </div>
  );
}
